module.exports = __webpack_public_path__ + "d0aafc448f4021290a070f7bb8f756f3.svg";